var _g, _path, _rect, _line, _line2, _line3, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoCamionLleno(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 15,
    fill: "#4F4184"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 14.5,
    stroke: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.55 21.3125H26.1V18.1484C26.1 17.7969 25.9312 17.416 25.6781 17.1523L22.8937 14.252C22.6406 13.9883 22.275 13.8125 21.9375 13.8125H20.7V12.4062C20.7 11.6445 20.0813 11 19.35 11H10.35C9.59062 11 9 11.6445 9 12.4062V21.7812C9 22.5723 9.59062 23.1875 10.35 23.1875H10.8C10.8 24.7402 12.0094 26 13.5 26C14.9906 26 16.2 24.7402 16.2 23.1875H19.8C19.8 24.7402 21.0094 26 22.5 26C23.9906 26 25.2 24.7402 25.2 23.1875H26.55C26.775 23.1875 27 22.9824 27 22.7188V21.7812C27 21.5469 26.775 21.3125 26.55 21.3125ZM13.5 24.5938C12.7406 24.5938 12.15 23.9785 12.15 23.1875C12.15 22.4258 12.7406 21.7812 13.5 21.7812C14.2312 21.7812 14.85 22.4258 14.85 23.1875C14.85 23.9785 14.2312 24.5938 13.5 24.5938ZM22.5 24.5938C21.7406 24.5938 21.15 23.9785 21.15 23.1875C21.15 22.4258 21.7406 21.7812 22.5 21.7812C23.2312 21.7812 23.85 22.4258 23.85 23.1875C23.85 23.9785 23.2312 24.5938 22.5 24.5938ZM24.75 18.5H20.7V15.2188H21.9375L24.75 18.1484V18.5Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 11.5,
    width: 10.25,
    height: 9.5,
    rx: 0.5,
    fill: "white",
    stroke: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 12.0996,
    y1: 20.96,
    x2: 12.0996,
    y2: 17.36,
    stroke: "#4F4184"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 14.9795,
    y1: 20.96,
    x2: 14.9795,
    y2: 17.36,
    stroke: "#4F4184"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 17.8599,
    y1: 20.96,
    x2: 17.8599,
    y2: 17.36,
    stroke: "#4F4184"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCamionLleno);
export default __webpack_public_path__ + "static/media/LogoCamionLleno.675a4322.svg";
export { ForwardRef as ReactComponent };